import { Box } from '@mui/material';
import { PropsWithChildren } from 'react';

const STATUS_SX = {
  flexShrink: 0,
} as const;

const InterruptionCreatorStatus = ({ children }: PropsWithChildren) => <Box sx={STATUS_SX}>{children}</Box>;

export default InterruptionCreatorStatus;
